import { IonLabel } from '@ionic/react';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Machine } from '../../api/graphql/generated';
import { useLoadedScratchpad } from '../../api/hooks/scratchpad.hooks';
import { MachineStateIcon } from './machine-state';
import './machine.css';

interface MachineProgramStatusProps {
  machine?: Machine;
  overrideProgramName?: string;
}
const MachineProgramStatus = (
  props: MachineProgramStatusProps
): ReactElement | null => {
  const { machine, overrideProgramName } = props;
  const { i18n } = useTranslation();

  const isMachineActive = machine?.active;

  const activeSratchpad = useLoadedScratchpad();
  const programName = machine?.state?.runtimeInfo?.programName;

  const program = useMemo(() => {
    if (!isMachineActive) {
      return <IonLabel color="danger">{i18n.t('common:inactive')}</IonLabel>;
    } else {
      return (
        overrideProgramName ??
        activeSratchpad?.name ??
        programName ??
        `<unknown program>`
      );
    }
  }, [
    overrideProgramName,
    activeSratchpad?.name,
    programName,
    isMachineActive,
    i18n,
  ]);

  if (machine) {
    return (
      <div className="machine-program-status">
        <MachineStateIcon machine={machine} />
        <div className="machine-program-label">{program}</div>
      </div>
    );
  }
  return null;
};

export { MachineProgramStatus };
